<template>
	<c-dialog ref="dialog" mode="slide" width="1000" mask-close @resolve="submitHandle">
		<c-form ref="form" column="3" vertical unit-width="100%">
			<c-form link-parent>
				<c-form-item label="调拨单号">
					<c-input name="transfer_code" :disabled="isEdit" placeholder="请输入，忽略将自动生成"></c-input>
				</c-form-item>
				<c-form-item label="调拨给" required>
					<c-select name="to_saas_id" v-model="toSaasId" :options="merchantOptions" placeholder="请选择调拨对象" @change="onMerchantChange"></c-select>
				</c-form-item>
				<c-form-item label="分润比例" required tips="aaaa">
					<!--比例取调拨对象管理配置值，创单/编辑均不可修改-->
					<c-input name="transfer_ratio" v-model="transferRatio" type="number" decimal="2" :range="[0, 100]" append-text="%" disabled placeholder="接收方销售后你方获得的利润比例"></c-input>
				</c-form-item>
				<c-form-item label="快递单号">
					<c-input name="express_no" placeholder="请输入快递单号"></c-input>
				</c-form-item>
				<c-form-item label="备注" colspan="2">
					<c-input type="textarea" name="remark" maxlength="200" placeholder="请输入备注"></c-input>
				</c-form-item>
			</c-form>

			<c-title>调拨商品明细</c-title>
			<c-form-item :label="false" name="product_list" colspan="3">
				<m-operate border>
					<c-input ref="codeInput" v-model="scanCode" placeholder="请扫描/输入背贴码" @keyup.enter.native="scanCodeHandle">
						<template #appendIcon><i class="tf-scan"></i></template>
					</c-input>
					<c-button color="main" @click="scanCodeHandle">确定</c-button>
					<c-button color="red" :hollow="true" prepend-icon="tf-trash" @click="batchRemove">批量移除</c-button>
				</m-operate>
				<c-table ref="productTable" :data="scannedList" border :paging="false">
					<template #empty>
						<c-empty message="请扫描产品背贴码"></c-empty>
					</template>
					<c-table-column type="selector" width="40"></c-table-column>
					<c-table-column label="产品信息" width="300">
						<template #default="{data}">
							<m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
						</template>
					</c-table-column>
					<c-table-column label="成本价" width="110">
						<template #default="{data}">
							<div>采购：<span class="price-text">{{fmtPrice(data.purchase_price)}}</span></div>
							<div>维修：<span class="price-text">{{fmtPrice(data.repair_cost)}}</span></div>
						</template>
					</c-table-column>
					<c-table-column label="当前接驳人" width="80">
						<template #default="{data}">{{data.current_duty_user_name || '-'}}</template>
					</c-table-column>
					<c-table-column label="入库时间" width="130">
						<template #default="{data}">{{data.stock_in_time || '-'}}</template>
					</c-table-column>
					<c-table-column label="操作" width="80" type="button">
						<template #default="{data}">
							<c-table-button color="red" icon="tf-trash" @click="removeItem(data)">移除</c-table-button>
						</template>
					</c-table-column>
				</c-table>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	import scanCodeGuard from '@/mixins/scan_code_guard';

	export default {
		name: 'profitTransferEdit',
		mixins: [scanCodeGuard],

		data() {
			return {
				isEdit: false,
				transferId: '',
				toSaasId: '',
				transferRatio: '',
				merchantOptions: [],
				scanCode: '',
				scannedList: []
			}
		},

		methods: {
			/*********打开弹窗（data 存在为编辑）**********/
			open(data) {
				this.isEdit = !!(data && data.id);
				this.transferId = data ? data.id : '';
				this.toSaasId = '';
				this.transferRatio = '';
				this.scanCode = '';
				this.scannedList = [];
				this.$refs.form.clear();
				this.loadMerchants();
				this.$refs.dialog.open({title: this.isEdit ? '编辑分润调拨' : '创建分润调拨'});
				if (this.isEdit) {
					this.loadDetail(data.id);
				} else {
					this.focusInput();
				}
			},

			/*********加载启用的调拨对象下拉**********/
			loadMerchants() {
				this.request({
					url: '/profitTransferMerchant/enabledList',
					data: {},
					success: list => {
						this.merchantOptions = (list || []).map(item => {
							return {name: item.merchant_name, value: item.merchant_saas_id, share_ratio: item.share_ratio};
						});
					}
				});
			},

			/*********编辑时加载单据详情**********/
			loadDetail(id) {
				this.request({
					url: '/profitTransfer/detail',
					data: {id: id},
					loading: true,
					success: info => {
						this.$refs.form.set({
							transfer_code: info.transfer_code || '',
							to_saas_id: info.to_saas_id,
							transfer_ratio: info.transfer_ratio,
							express_no: info.express_no || '',
							remark: info.remark || ''
						});
						this.toSaasId = info.to_saas_id;
						this.transferRatio = info.transfer_ratio;
						this.scannedList = (info.product_list || []).map(item => {
							return {
								produce_unique_code_id: item.produce_unique_code_id,
								produce_unique_code: item.produce_unique_code,
								produce_imei: item.produce_imei,
								product_info: item.product_info,
								level_type: item.level_type,
								cost_price: item.cost_price,
								purchase_price: item.purchase_price,
								repair_cost: item.repair_cost,
								current_duty_user_name: item.current_duty_user_name,
								stock_in_time: item.stock_in_time
							};
						});
						this.focusInput();
					}
				});
			},

			/*********选择调拨对象时带入默认分润比例（不可修改，切换对象即刷新）**********/
			onMerchantChange() {
				let merchant = this.merchantOptions.find(item => item.value == this.toSaasId);
				if (merchant) {
					this.transferRatio = merchant.share_ratio;
					this.$refs.form.set({transfer_ratio: merchant.share_ratio});
				}
			},

			/*********聚焦扫码输入框**********/
			focusInput() {
				this.$nextTick(() => {
					var input = this.$refs.codeInput && this.$refs.codeInput.$el.querySelector('input');
					if (input) input.focus();
				});
			},

			/*********扫码处理**********/
			scanCodeHandle() {
				var code = (this.scanCode || '').trim();
				if (!code) {
					this.$message({message: '请输入背贴码', type: 'warning'});
					return;
				}
				if (this.scannedList.some(item => item.produce_unique_code == code)) {
					this.$message({message: '该背贴码已扫描', type: 'warning'});
					this.scanCode = '';
					this.focusInput();
					return;
				}
				//防止连续点击【确定】对同一背贴码并发请求，导致已扫列表重复录入
				if (this.isScanCodePending(code)) {
					this.$message({message: '该背贴码正在校验，请勿重复提交', type: 'warning'});
					return;
				}
				this.lockScanCode(code);
				this.request({
					url: '/profitTransfer/scan',
					data: {code: code},
					success: row => {
						this.pushScannedItem(row, code);
						this.scanCode = '';
						this.focusInput();
					},
					fail: (code, data, msg) => {
						this.$message({message: msg || '扫描失败', type: 'error'});
						this.scanCode = '';
						this.focusInput();
						return false;
					},
					complete: () => {
						this.unlockScanCode(code);
					}
				});
			},

			/*********成本价展示（0 显示 ¥0，空值显示 -）**********/
			fmtPrice(v) {
				return (v === null || v === undefined || v === '') ? '-' : '¥' + v;
			},

			/*********产品信息文字兜底**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.spu_model_name) parts.push(data.spu_model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join('/') || '-';
			},

			/*********移除已扫项**********/
			removeItem(data) {
				this.scannedList = this.scannedList.filter(item => item.produce_unique_code_id != data.produce_unique_code_id);
				this.focusInput();
			},

			/*********批量移除选中项**********/
			batchRemove() {
				let selectedList = this.$refs.productTable.getData('selected');
				if (!selectedList || selectedList.length == 0) {
					this.$message({message: '请先勾选要移除的记录', type: 'warning'});
					return;
				}
				var ids = selectedList.map(item => item.produce_unique_code_id);
				this.scannedList = this.scannedList.filter(item => !ids.includes(item.produce_unique_code_id));
				this.focusInput();
			},

			/*********提交**********/
			submitHandle(stop, next) {
				stop();
				var product_list = this.$refs.productTable.getData();
				if (!product_list || product_list.length == 0) {
					this.$message({message: '请至少添加一件调拨商品', type: 'warning'});
					return;
				}
				if (this.transferRatio === '' || this.transferRatio === null || this.transferRatio === undefined) {
					this.$message({message: '当前调拨对象未配置分润比例，请在调拨对象管理中维护', type: 'warning'});
					return;
				}
				this.$refs.form.submit({
					url: this.isEdit ? '/profitTransfer/update' : '/profitTransfer/create',
					rule: {
						to_saas_id: '请选择调拨给商户'
					},
					dataFormatter: data => {
						if (this.isEdit) {
							data.id = this.transferId;
						}
						//比例输入框禁用，显式以带入值覆盖提交，避免禁用字段不参与表单收集
						data.transfer_ratio = this.transferRatio;
						data.produce_unique_code_ids = product_list.map(item => item.produce_unique_code_id);
						return data;
					},
					success: (data, res, msg) => {
						next();
						this.$refs.dialog.close();
						this.$message({message: msg || (this.isEdit ? '编辑成功' : '创建成功'), type: 'success'});
						this.$emit('resolve');
					},
					fail: (data, code, res, msg) => {
						this.$message({message: msg, type: 'error'});
						return false;
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.price-text {
		color: #333;
		text-decoration: underline;
	}
</style>
